import Api from './Api'

export default {
    getSites(obj) {
        return Api().post('sites', obj)
    },
    getCustomerDevelopmentUrl() {
        return Api().get('customerDevelopmentUrl')
    }
}